import { faTimes } from '@fortawesome/pro-light-svg-icons';

import { Icon } from '@/components/ui/icon.component';
import { SheetClose, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { StepKeys } from '@/app/(main)/_components/sign-in-modal/_types/header-auth-modal-step-keys.enum';
import { removeRegistrationCookies } from '@/cookies/registration.cookies';
import { useProgressiveModal } from '@/components/ui/progressive-modal/progressive-modal.hook';
import LoginForm from '@/app/(main)/_components/sign-in-modal/_components/login-form.component';

export default function LoginStep() {
  const { handleJump: jump, onClose } = useProgressiveModal<StepKeys>();

  const handleCreateAccount = () => {
    if (jump) {
      removeRegistrationCookies();
      jump({ key: StepKeys.REGISTER });
    }
  };

  return (
    <div className="flex flex-col h-full md:max-h-[40rem]" data-testid="login-div--login-step">
      <SheetHeader className="bg-white">
        <div className="flex justify-between gap-3 pb-4 items-center">
          <div className="flex gap-3">
            <SheetTitle>
              <div className="flex gap-3">
                <span className="font-extrabold text-2xl text-gray-900 text-nowrap">Entrar</span>
              </div>
            </SheetTitle>
          </div>
          <SheetClose
            asChild
            className="text-gray-500 cursor-pointer self-center px-2 hover:bg-gray-50"
            onClick={onClose}
          >
            <Icon icon={faTimes} size="xl" className="hover:text-gray-900 text-[1.625rem]" />
          </SheetClose>
        </div>
      </SheetHeader>
      <div className="flex flex-col gap-6">
        <LoginForm />
        <div className="flex flex-col items-center gap-1">
          <p className="text-gray-800 font-normal leading-5">Ainda não possui conta?</p>
          <p className="text-green-500 font-semibold leading-6 cursor-pointer" onClick={handleCreateAccount}>
            Cadastre-se
          </p>
        </div>
      </div>
    </div>
  );
}
